<template>
  <div>
    <form class="" method="POST" action="" v-on:submit.prevent="joinUs" v-bind:class="formClass"
          v-if="formClass === 'form-inline'">
      <div class="form-group">
        <input type="text" class="form-control form-control-sm" v-model="subscribe_email"
               style="height:27px; width:55%;">
        &nbsp;
        <button type="submit" class="btn btn-red form-control txt-upper btn-sm">Count Me In! </button>
      </div>
      <p class="error"> {{ joinusMsg }}</p>
    </form>

    <form class="" method="POST" action="" v-on:submit.prevent="joinUs" v-else>
      <input type="text" class="form-control mb10" v-model="subscribe_email">
      <button type="submit" class="btn btn-red form-control txt-upper ">Count Me In! </button>
      <p class="error"> {{ joinusMsg }}</p>
    </form>

  </div>
</template>
<script>
  export default {
    props: ['formClass'],
    data () {
      return {
        subscribe_email: '',
        joinusMsg: ''
      }
    },
    methods: {
      joinUs () {
        this.$set(this.$parent, 'loading', true)
        this.axios.post('api/v1/subscribe?email=' + this.subscribe_email).then((response) => {
          this.joinusMsg = response.data.message
          this.$set(this.$parent, 'loading', false)
        })
      }
    }
  }
</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// subscribeNewsletter.vue?24181b0e